import React__default from 'react';

const tableBody = "_table-body_13cvx_1";
const styles = {
	tableBody: tableBody
};

const TableBody = (props) => {
  return React__default.createElement("tbody", { css: styles.tableBody, "data-zds": true }, props.children);
};

export { TableBody };
//# sourceMappingURL=TableBody.es.js.map
